import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Card, IconButton } from "@deere/fuel-react";
import { ReactComponent as DragIcon } from "@deere/ux.brand-foundations/icons/menu.svg";
import { ReactComponent as InfoIcon } from "@deere/ux.brand-foundations/icons/info.svg";
import { DEPENDENT_QUESTION } from "../../../../utils/surveyLiterals";

const SortableItem = ({ que }) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: que.code });
  const queLabel = que.text.length >= 100 ? que.text.substring(0, 100) + "..." : que.text;
  return (
    <Card title={que.text} sx={{ transform: CSS.Transform.toString({ ...transform, x: 0 }), transition, padding: "5px" }} ref={setNodeRef} {...attributes}>
      <IconButton {...listeners} style={{ cursor: "grab", marginRight: "10px" }}>
        <DragIcon />
      </IconButton>
      {que.codeQuestionDepends && que.codeQuestionDepends !== "" && <InfoIcon height={18} width={18} title={DEPENDENT_QUESTION} />}
      {queLabel}
    </Card>
  );
};

export default SortableItem;
